

































import Vue from 'vue'
import {
  TaskNodeFragment,
  SpecificActiveTaskQuery,
  SpecificActiveTaskQueryVariables,
  CaseNodeFragment,
} from '@/graphql-schema'

import { GetMyOffer } from './InterviewerEntersRoom.graphql'
import { InterviewerEntersRoomTask } from '@/queries/tasks.graphql'
import InterviewerEntersRoom from './InterviewerEntersRoom.vue'
import { wrapVariables } from '@/utils'

export default Vue.extend({
  apollo: {
    offers: {
      query: GetMyOffer,
      variables() {
        return {
          id: this.offerId,
        }
      },
    },
  },
  components: {
    InterviewerEntersRoom,
  },
  methods: {
    ok() {
      const that = this
      if (this.selectedTask) {
        this.$store
          .dispatch({
            type: 'workflow/completeTask',
            task: this.selectedTask,
            variables: wrapVariables(this.taskForm || {}),
          })
          .then(() => {
            //brauchen wir nichr mehr, da der Button direkt ein Link ist
            //window.open(that.externalLink, "_blank")
            this.$emit('linkClicked')
          })
      }
    },
    cancel(): void {
      this.$router.push({ name: 'admin.tasks' })
    },
  },
  computed: {
    relatedCase(): CaseNodeFragment | null | undefined {
      return this.selectedTask?.case
    },
    externalLink(): string {
      if (this.offers != null && this.offers.nodes != null && this.offers.nodes.length > 0) {
        return this.offers.nodes[0].externalLink || '#'
      }
      return '#'
    },
  },
  data() {
    return {
      offers: { nodes: [] },
      taskForm: {},
      locale: 'en',
      sent: false,
    }
  },
  props: {
    offerId: {
      type: String,
      required: true,
    },
    value: {
      required: true,
      type: Object,
    },
    caseId: {
      type: String,
      required: true,
    },
    selectedTask: {
      type: Object,
      required: true,
    },
  },
})
